import React from 'react'

import Logo from '../../svg/brand.svg'
import * as S from './styled'

const Brand = ({ ...rest }) => (
  <S.BrandWrapper {...rest}>
    <Logo />
  </S.BrandWrapper>
)

export default Brand
